<template>
    <div class="inputs inputs--budget-calculation">
        <p>Estimer votre budget de communication en fonction de votre chiffre d'affaire prévisionnel</p>
        <form @submit.prevent="onSubmit">
            <div class="row">
                <div class="form-group col-xs-12">
                    <label for="ca-input">CA previsionnel</label>
                    <div class="input-group">
                        <input type="number" id="ca-input" name="ca" class="form-control" @focus="isWrongClass = false" v-model="ca" :class="{'is-wrong': isWrongClass}">
                        <div class="input-group-addon">€</div>
                    </div>
                </div>
            </div>
            <input type="submit" class="btn btn-lg btn-primary" @click.prevent="onSubmit" value="Je calcule"></input>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ca: '',
                isWrongClass: false
            }
        },
        methods: {
            onSubmit() {
                //le champ CA doit etre rensigné
                if(this.ca) {
                    //calcule du montant
                    this.$store.state.budget.result = Math.round(this.ca * 6 / 100);
                    this.$store.state.budget.showResultPart = "calculation";
                    this.$store.commit('showBudgetResult');
                    //on force la fermeture du keyboard pour IOS en desactivant le focus
                    document.activeElement.blur();
                } else {
                    this.isWrongClass = true;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// BudgetCalculation.vue?603794f8